import axios from "axios";
export const addNoteCall = async (note) => {
  try {
    const { data, status } = await axios.post(
      "/api/notes",
      { note },
      {
        headers: {
          authorization: localStorage.getItem("userLoginToken"),
        },
      }
    );

    return { notes: data.notes, status };
  } catch (error) {
    console.error(error);
    return error;
  }
};
